import MobileLayout from './Mobile/PopupFormLayout.mobile';
import WebLayout from './Web/PopupFormLayout.web';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
